var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-header px"},[_c('div',{staticClass:"header-content"},[_c('a',{attrs:{"href":_vm.url.officialWebsite,"target":"_blank"}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.images.logo,"alt":"logo"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }